import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Brand, Colors, Typography } from '../constants';

interface StatsBadgeProps {
  /** The numeral */
  value: number | string;
  /** Short unit ("items", "new", "clubs") */
  label: string;
  /** Screen-reader hint ("Last 24h") */
  sublabel?: string;
  /** White numeral + saliemist label, for Bosgroen grounds */
  onDark?: boolean;
}

/**
 * Numeral stat (design v2): bold 20 number + medium 12 label on one baseline,
 * no background pill. Ink on light panels; pass `onDark` on Bosgroen.
 */
export const StatsBadge: React.FC<StatsBadgeProps> = ({ value, label, sublabel, onDark = false }) => {
  return (
    <View style={styles.container} accessibilityLabel={sublabel ? `${value} ${label} (${sublabel})` : undefined}>
      <Text style={[styles.value, onDark && styles.valueOnDark]}>{value}</Text>
      <Text style={[styles.label, onDark && styles.labelOnDark]}>{label}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'baseline',
    gap: 6,
  },
  value: {
    ...Typography.statValue,
    color: Colors.textDark,
  },
  valueOnDark: {
    color: Colors.white,
  },
  label: {
    ...Typography.statLabel,
    color: Colors.textLight,
  },
  labelOnDark: {
    color: Brand.saliemist,
  },
});
